import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type ChatRoomListItemFragment = { __typename?: 'ChatRoom', id: string, updatedAt: TimeString, status: Types.ChatRoomStatus, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, match: { __typename?: 'Match', id: string, isAssigned: boolean, normalMessageChatReplyMatchSetting: { __typename?: 'NormalMessageChatReplyMatchSetting', disabledUntil?: TimeString | null } }, planner: { __typename?: 'Planner', id: string, name: string, avatar?: any | null, chatParticipant?: { __typename?: 'ChatParticipant', id: string } | null }, user?: { __typename?: 'User', id: string, birthYear?: number | null, nickname: string, gender: Types.UserGender, livingPrefecture?: Types.Prefecture | null, financialServicesAgent?: string | null, karte?: { __typename?: 'Karte', userComment: string } | null, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null, diagnosisResult?: { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } } | null } | null, memos: Array<{ __typename?: 'ChatRoomMemo', id: string, content: string, createdAt: TimeString }> };

export type ChatRoomListUserFragment = { __typename?: 'User', id: string, birthYear?: number | null, nickname: string, gender: Types.UserGender, livingPrefecture?: Types.Prefecture | null, financialServicesAgent?: string | null, karte?: { __typename?: 'Karte', userComment: string } | null, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null, diagnosisResult?: { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } } | null };

export type DiagnosisResultFragment = { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } };

export const DiagnosisResultFragmentDoc = gql`
    fragment DiagnosisResult on DiagnosisResult {
  personality {
    type
    title
    description
  }
}
    `;
export const ChatRoomListUserFragmentDoc = gql`
    fragment ChatRoomListUser on User {
  id
  karte {
    userComment
  }
  birthYear
  nickname
  gender
  livingPrefecture
  address {
    prefecture
    city
  }
  diagnosisResult {
    ...DiagnosisResult
  }
  financialServicesAgent
}
    ${DiagnosisResultFragmentDoc}`;
export const ChatRoomListItemFragmentDoc = gql`
    fragment ChatRoomListItem on ChatRoom {
  id
  updatedAt
  status
  hasUnreadMessage
  hasUnrepliedMessage
  match {
    id
    isAssigned
    normalMessageChatReplyMatchSetting {
      disabledUntil
    }
  }
  planner {
    id
    name
    avatar
    chatParticipant {
      id
    }
  }
  user {
    ...ChatRoomListUser
  }
  memos {
    id
    content
    createdAt
  }
}
    ${ChatRoomListUserFragmentDoc}`;